import { ConditionAddComponent } from './condition-add.component';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import {
  MatDatepickerModule,
  MAT_DATE_LOCALE, MatSelectModule, MatFormFieldModule, MatInputModule, MatNativeDateModule, MatAutocompleteModule
} from '@angular/material';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { FileAddModule } from '../../../shared/components/file-add/file-add.module';

@NgModule({
  declarations: [ConditionAddComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatDatepickerModule,
    MatSelectModule,
    MatFormFieldModule,
    MatNativeDateModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatAutocompleteModule,
    FileAddModule
  ],
  exports: [ConditionAddComponent],
  providers: [
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: 'hu-HU' }
  ]
})
export class ConditionAddModule { }
